var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',_vm._l((_vm.roles),function(role,index){return _c('v-col',{key:index},[_c('v-checkbox',{attrs:{"label":role.label,"rules":_vm.rules,"value":role.role},model:{value:(_vm.instructorRolesProxy),callback:function ($$v) {_vm.instructorRolesProxy=$$v},expression:"instructorRolesProxy"}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }